import { useState, useEffect } from "react";
import Filter from "./Filter";
import { notification } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Translate } from "../../translate";
import moment from "moment";
import { getStore } from "../../utils/global";
import axios from "../../utils/axios";
import Loading from "../Loading";

const HomeRouter = () => {
  const [loading, setLoading] = useState(false);
  const [savedTree, setSavedTree] = useState(0);
  const [savedWater, setSavedWater] = useState(0);
  const [thisMonthTree, setThisMonthTree] = useState(0);
  const [thisMonthWater, setThisMonthWater] = useState(0);
  const [docsCountAllTime, setDocsCountAllTime] = useState({
    total: 0,
    complete: 0,
    sent: 0,
    received: 0,
    waiting: 0,
    archived: 0,
    cancelled: 0,
    rejected: 0,
  });
  const [docCountThisMonth, setDocCountThisMonth] = useState({
    total: 0,
    complete: 0,
    sent: 0,
    received: 0,
    waiting: 0,
    archived: 0,
    cancelled: 0,
    rejected: 0,
  });

  const init = () => {
    setLoading(true);
    const user = getStore("user");
    axios
      .post("client/api/doc/home", { begin_date: moment().startOf("month").toDate(), end_date: new Date() })
      .then((e) => {
        setDocCountThisMonth(e?.data?.count);
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        notification["error"]({
          message: "Алдаа гарлаа ",
          description: e?.data?.message,
        });
      });
    axios
      .post("client/api/doc/home", { begin_date: new Date("2019-01-01"), end_date: new Date() })
      .then((e) => {
        setDocsCountAllTime(e?.data?.count);
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        notification["error"]({
          message: "Алдаа гарлаа ",
          description: e?.data?.message,
        });
      });
    axios.post("/admin/api/orginization/stats/user", { userid: user.kdss_user, begin_date: new Date("2019-01-01"), end_date: new Date() }).then((res) => {
      const pages = res?.data?.stats?.documents.pages;
      if (!pages) return;
      setSavedTree((pages / 8100).toFixed(3));
      setSavedWater(pages * 10);
    });

    axios
      .post("/admin/api/orginization/stats/user", {
        userid: user.kdss_user,
        begin_date: moment().startOf("month").toDate(),
        end_date: new Date(),
      })
      .then((res) => {
        const pages = res?.data?.stats?.documents.pages;
        if (!pages) return;
        setThisMonthTree((pages / 8100).toFixed(3));
        setThisMonthWater(pages * 10);
      });
  };

  useEffect(() => {
    init();
  }, []);

  let ln = typeof getStore("lang") === "object" ? "en" : getStore("lang");

  return (
    <div className="home_router_container">
      <Loading loading={loading} />
      <div className="mini_title">{Translate[ln].Home.Alltime}</div>
      <div className="home_filter_container">
        {!!docsCountAllTime &&
          Object.keys(docsCountAllTime).map((key) => {
            return <Filter key={key} count={docsCountAllTime[key]} dataKey={key} />;
          })}
        <div className="trees_container">
          <FontAwesomeIcon icon={["fas", "tree"]} className="card_icon" color="rgb(20, 161, 15)" />
          <span>{savedTree}</span>
          <div>{Translate[ln].Home.Filters.Trees}</div>
        </div>
        <div className="trees_container">
          <FontAwesomeIcon icon={["fas", "tint"]} className="card_icon" color="#1975ee" />
          <span>
            {savedWater} {Translate[ln].Home.Filters.Litre}
          </span>
          <div> {Translate[ln].Home.Filters.Water}</div>
        </div>
      </div>
      <div className="mini_title" style={{ paddingTop: 20 }}>
        {Translate[ln].Home.Thismonth}
      </div>
      <div className="home_filter_container">
        {!!docCountThisMonth &&
          Object.keys(docCountThisMonth)?.map((key) => {
            return <Filter key={key} count={docCountThisMonth[key]} dataKey={key} />;
          })}
        <div className="trees_container">
          <FontAwesomeIcon icon={["fas", "tree"]} className="card_icon" color="rgb(20, 161, 15)" />
          <span>{thisMonthTree}</span>
          <div>{Translate[ln].Home.Filters.Trees}</div>
        </div>
        <div className="trees_container">
          <FontAwesomeIcon icon={["fas", "tint"]} className="card_icon" color="#1975ee" />
          <span>
            {thisMonthWater} {Translate[ln].Home.Filters.Litre}
          </span>
          <div>{Translate[ln].Home.Filters.Water}</div>
        </div>
      </div>
    </div>
  );
};

export default HomeRouter;
